import { AppName } from '../../../types/app/app'
import { ProfileItem, ProfileVersion } from '../../../types/users/profile'
import { gynTab, patientTab, v1PatientTabs } from './patientTabs'
import { getV1PregnancyTabs, getV2PregnancyTabs } from './pregnancyTabs'
import { SubTab, SubTabGroup } from './types'

const getV1BaseItemTabs = (appName: AppName, baseItem: ProfileItem | null) => {
  if (!baseItem) return v1PatientTabs
  switch (baseItem.type) {
    case 'claim':
    case 'pregnancy':
      return getV1PregnancyTabs(appName)
    default:
      return v1PatientTabs
  }
}

const getV2BaseItemTabs = (
  appName: AppName,
  selectedItem: ProfileItem | null,
): Array<SubTab | SubTabGroup> => {
  if (!selectedItem) return [patientTab, gynTab]
  switch (selectedItem.type) {
    case 'claim':
    case 'pregnancy':
      return getV2PregnancyTabs(appName, selectedItem.id)
    default:
      return [patientTab, gynTab]
  }
}

export const getBaseItemTabs = (
  appName: AppName,
  selectedItem: ProfileItem | null,
  profileVersion: ProfileVersion,
): Array<SubTab | SubTabGroup> =>
  profileVersion === 'v1'
    ? getV1BaseItemTabs(appName, selectedItem)
    : getV2BaseItemTabs(appName, selectedItem)
